import React from "react";
import { Link } from "react-router-dom";
import { Mail, Instagram, Facebook, Twitter, Heart } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy text-white">
      <div className="container mx-auto px-4 md:px-6 py-12 md:py-16 w-full max-w-full">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          <div className="md:col-span-1">
            <Link
              to="/"
              className="text-gold font-playfair text-xl font-semibold inline-block mb-4"
            >
              GlowHer<span className="text-white">.Life</span>
            </Link>
            <p className="text-white/70 mb-6">
              Where Smart Living Meets Timeless Elegance
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="text-white/80 hover:text-gold transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="text-white/80 hover:text-gold transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="text-white/80 hover:text-gold transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="mailto:contact@glowher.life"
                className="text-white/80 hover:text-gold transition-colors"
                aria-label="Email"
              >
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-white mb-4">Categories</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/articles?category=smart-living"
                  className="text-white/70 hover:text-gold transition-colors"
                >
                  Smart Living
                </Link>
              </li>
              <li>
                <Link
                  to="/articles?category=beauty"
                  className="text-white/70 hover:text-gold transition-colors"
                >
                  Glow & Beauty
                </Link>
              </li>
              <li>
                <Link
                  to="/articles?category=health"
                  className="text-white/70 hover:text-gold transition-colors"
                >
                  Health & Family
                </Link>
              </li>
              <li>
                <Link
                  to="/articles?category=shop"
                  className="text-white/70 hover:text-gold transition-colors"
                >
                  Shop & Reviews
                </Link>
              </li>
              <li>
                <Link
                  to="/articles?category=shop"
                  className="text-white/70 hover:text-gold transition-colors"
                >
                  Blog & Stories
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-white/70 hover:text-gold transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-white/70 hover:text-gold transition-colors"
                >
                  Contact
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/privacy"
                  className="text-white/70 hover:text-gold transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-white/70 hover:text-gold transition-colors"
                >
                  Terms of Service
                </Link>
              </li> */}
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-white mb-4">Contact Us</h3>
            <a
              href="mailto:contact@glowher.life"
              className="text-white/70 hover:text-gold transition-colors inline-flex items-center mb-2"
            >
              <Mail className="h-4 w-4 mr-2" />
              contact@glowher.life
            </a>
            <p className="text-white/70">
              For reader support and advertising partnerships
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/60 text-sm">
            &copy; {currentYear} GlowHer.Life. All rights reserved.
          </p>
          <p className="text-white/60 text-sm flex items-center mt-4 md:mt-0">
            <span>Made with</span>
            <Heart className="h-3 w-3 mx-1 text-gold" />
            <span>for smart, stylish women</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
